import { Checkbox, TableCell, TableRow } from '@mui/material';
import React, { useContext } from 'react';
import { WbTableContext } from './WbTable';

interface WbTableRowProps {
  children: any;
  id: number;
}

export const WbTableRow: React.FC<WbTableRowProps> = ({children, id}) => {
  const {selectedIds, setSelectedItem} = useContext(WbTableContext);
  const isSelected = selectedIds.includes(id);
  return (
    <TableRow hover selected={isSelected}>
      <TableCell padding="checkbox">
        <Checkbox
          color="primary"
          checked={isSelected}
          onChange={(_, checked) => setSelectedItem(id, checked)}
          value={isSelected}
        />
      </TableCell>
      {React.Children.map(children, (child) => React.cloneElement(child))}
    </TableRow>
  );
};
